
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { InvitationTableRow } from "./InvitationTableRow";
import { Invitation } from "@/services/employees/invitation/fetchInvitations";

interface InvitationsTableProps {
  invitations: Invitation[];
  storeNameMap: (storeId: string) => string;
  onResendInvitation: (invitation: Invitation) => Promise<void>;
  onDeleteInvitation: (invitation: Invitation) => void;
  resendingIds: string[];
  deletingIds: string[];
}

export function InvitationsTable({
  invitations,
  storeNameMap,
  onResendInvitation,
  onDeleteInvitation,
  resendingIds,
  deletingIds,
}: InvitationsTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Store</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Invited</TableHead>
          <TableHead>Expires</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {invitations.map((invitation) => (
          <InvitationTableRow
            key={invitation.id}
            invitation={invitation}
            storeName={storeNameMap(invitation.store_id)}
            onResendInvitation={onResendInvitation}
            onDeleteInvitation={onDeleteInvitation}
            resendingIds={resendingIds}
            deletingIds={deletingIds}
          />
        ))}
      </TableBody>
    </Table>
  );
}
